(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbd-halloween"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';
    if (document.documentElement.dataset.bbdHalloweenReady === 'true') return;
    document.documentElement.dataset.bbdHalloweenReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const cartSelector = '[data-testid="cart-drawer-trigger"]';
    const actionSelector = `${cartSelector}, .bbd-btn, .bbd-product-cta, .add-to-cart-button, .bbd-hw-badge`;
    const svgOpen = '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"';
    const pumpkin = '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="bbd-hw-pumpkin" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 6V4c0-1.3 1.1-2 2.4-2M10 6C5.8 3.5 2.5 6.5 2.5 11.5c0 4.3 3.3 6.5 7.5 6 4.2.5 7.5-1.7 7.5-6C17.5 6.5 14.2 3.5 10 6Z"/><path d="M10 6c-2.7 0-4.2 2.5-4.2 5.5s1.5 6 4.2 6m0-11.5c2.7 0 4.2 2.5 4.2 5.5s-1.5 6-4.2 6m0-11.5v11.5"/></svg>';
    const pumpkinDecor = pumpkin.replace('class="bbd-hw-pumpkin"', 'class="bbd-hw-pumpkin-decor"');
    const bat = `${svgOpen}><path d="M18 14l-3-5-2 7C9 17 5 12 2 8c0 8 2 15 8 16 2-3 4-1 5 2l3 4 3-4c1-3 3-5 5-2 6-1 8-8 8-16-3 4-7 9-11 8l-2-7-3 5Z" fill="currentColor"/></svg>`;
    const star = `${svgOpen}><path d="m18 3 4 11 11 4-11 4-4 11-4-11-11-4 11-4Z" fill="currentColor"/></svg>`;
    const ghost = `${svgOpen}><path d="M8 30V15a10 10 0 0 1 20 0v15l-5-3-5 3-5-3Z" fill="#fff8e9" stroke="#7e4a2b" stroke-width="1.5" stroke-linejoin="round"/><ellipse cx="14" cy="16" rx="1.5" ry="2" fill="#7e4a2b"/><ellipse cx="22" cy="16" rx="1.5" ry="2" fill="#7e4a2b"/><path d="M16 22q2 2 4 0" fill="none" stroke="#7e4a2b" stroke-width="1.4" stroke-linecap="round"/></svg>`;
    const moon = '<svg class="bbd-hw-moon" aria-hidden="true" focusable="false" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="63" cy="36" r="27" fill="#ffedc6"/><path d="M73 9a27 27 0 0 0 17 42 27 27 0 0 1-17-42Z" fill="#efd7a1" opacity=".6"/><g fill="#3c3027"><path d="m25 41-4-5-1 7c-5 2-9-2-13-6 1 9 5 13 10 13 3-4 5-1 8 2 3-3 5-6 8-2 5 0 9-4 10-13-4 4-8 8-13 6l-1-7Z"/><path d="m67 72-3-3-1 4c-3 1-6-1-8-4 1 5 3 8 7 8 1-2 3-1 5 1 2-2 4-3 5-1 4 0 6-3 7-8-2 3-5 5-8 4l-1-4Z"/></g><path d="m44 12 1 4 4 1-4 1-1 4-1-4-4-1 4-1Zm43 52 1 3 3 1-3 1-1 3-1-3-3-1 3-1Z" fill="#fff4d8"/></svg>';
    const web = '<svg class="bbd-hw-web" aria-hidden="true" focusable="false" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1v86M1 1h86M1 1l63 63M1 1l80 33M1 1l33 80M1 23c8-2 13 3 16 9 5-1 11 2 15 7M1 44c12-2 24 5 29 15 10-2 19 1 27 7M1 68c17-3 33 6 40 20M23 1c-2 8 3 13 9 16-1 5 2 11 7 15M44 1c-2 12 5 24 15 29-2 10 1 19 7 27M68 1c-3 17 6 33 20 40" stroke="currentColor" stroke-width="1.2"/></svg>';
    let headerObserver;
    let observedHeader;
    let cartObserver;
    let observedCart;
    let lastBurst = 0;
    const animations = new WeakMap();

    function decoration(className, markup) {
      const element = document.createElement('div');
      element.className = className;
      element.setAttribute('aria-hidden', 'true');
      element.innerHTML = markup;
      return element;
    }

    function ribbon() {
      const hanging = (icon) => `<span class="bbd-hw-hanging">${icon}</span>`;
      return decoration('bbd-hw-ribbon', `${hanging(bat)}${hanging(ghost)}${hanging(pumpkinDecor)}<span class="bbd-hw-ribbon-title">Halloween chez BBD</span>${hanging(pumpkinDecor)}${hanging(ghost)}${hanging(bat)}`);
    }

    function applyCartDecor() {
      const cart = document.querySelector('#cart-drawer');
      const heading = cart?.querySelector('.theme-drawer__header');
      if (heading && !cart.querySelector('.bbd-hw-cart-note')) {
        heading.after(decoration('bbd-hw-cart-note', `${bat}<span>Des petits plaisirs ensorcelés</span>${ghost}`));
      }
      if (cart && cart !== observedCart) {
        cartObserver?.disconnect();
        observedCart = cart;
        cartObserver = new MutationObserver(() => {
          if (cart.querySelector('.theme-drawer__header') && !cart.querySelector('.bbd-hw-cart-note')) applyCartDecor();
        });
        cartObserver.observe(cart, { childList: true, subtree: true });
      }
    }

    function applyDecor() {
      document.body.classList.add('bbd-halloween');
      document.querySelectorAll(`${cartSelector} cart-icon > .svg-wrapper`).forEach((wrapper) => {
        if (!wrapper.querySelector('.bbd-hw-pumpkin')) wrapper.insertAdjacentHTML('beforeend', pumpkin);
      });
      const main = document.querySelector('#MainContent');
      if (main && !main.previousElementSibling?.classList.contains('bbd-hw-ribbon')) main.before(ribbon());
      const topRow = document.querySelector('#header-component .header__row');
      if (topRow && !topRow.querySelector('.bbd-hw-header-decor')) {
        topRow.append(decoration('bbd-hw-header-decor', `${web}${web}`));
      }
      const footer = document.querySelector('footer');
      if (footer) {
        footer.classList.add('bbd-hw-footer');
        if (!footer.querySelector('.bbd-hw-ribbon')) footer.prepend(ribbon());
      }
      if (!document.querySelector('.bbd-hw-rails')) {
        document.body.append(decoration('bbd-hw-rails', `<div class="bbd-hw-rail">${bat}${ghost}${pumpkinDecor}</div><div class="bbd-hw-rail">${ghost}${pumpkinDecor}${bat}</div>`));
      }
      const pageTitle = main?.querySelector('h1:not(.visually-hidden)');
      if (pageTitle && !pageTitle.closest('.bbd-home') && !pageTitle.querySelector('.bbd-hw-title-mark')) {
        const marker = document.createElement('span');
        marker.className = 'bbd-hw-title-mark';
        marker.setAttribute('aria-hidden', 'true');
        marker.innerHTML = pumpkinDecor;
        pageTitle.prepend(marker);
      }
      document.querySelectorAll('.bbd-home > .bbd-wrap:not(.bbd-story):not(.bbd-bottom), .bbd-products-section > .bbd-wrap, .bbd-compare, .bbd-faq, #bbd-livraison').forEach((section, index) => {
        if (!section.querySelector(':scope > .bbd-hw-section-divider')) section.prepend(decoration('bbd-hw-section-divider', index % 2 ? pumpkinDecor : bat));
      });
      applyCartDecor();
      const heroCopy = document.querySelector('.bbd-hero-copy');
      if (heroCopy && !heroCopy.querySelector('.bbd-hw-badge')) {
        const badge = document.createElement('button');
        badge.type = 'button';
        badge.className = 'bbd-hw-badge';
        badge.setAttribute('aria-label', 'Halloween tout doux : lancer une petite envolée de chauves-souris');
        badge.innerHTML = `${ghost}<span>Un Halloween tout doux</span>${star.replace('<svg ', '<svg class="bbd-hw-badge-star" ')}`;
        heroCopy.prepend(badge);
        const status = document.createElement('span');
        status.className = 'bbd-hw-sr';
        status.setAttribute('role', 'status');
        heroCopy.append(status);
      }
      const photo = document.querySelector('.bbd-hero-photo');
      if (photo && !photo.querySelector('.bbd-hw-picture-decor')) {
        const decor = document.createElement('span');
        decor.className = 'bbd-hw-picture-decor';
        decor.setAttribute('aria-hidden', 'true');
        decor.innerHTML = `${web}${moon}`;
        photo.append(decor);
      }
      const header = document.querySelector('#header-component');
      if (header && header !== observedHeader) {
        if (headerObserver) headerObserver.disconnect();
        observedHeader = header;
        headerObserver = new MutationObserver(() => {
          if (header.querySelector(`${cartSelector} cart-icon > .svg-wrapper:not(:has(.bbd-hw-pumpkin))`)) applyDecor();
        });
        headerObserver.observe(header, { childList: true, subtree: true });
      }
    }

    function burst(button, event) {
      if (reducedMotion.matches || typeof Element.prototype.animate !== 'function') return;
      const now = performance.now();
      if (now - lastBurst < 220) return;
      lastBurst = now;
      const rect = button.getBoundingClientRect();
      const x = event.detail && event.clientX ? event.clientX : rect.left + rect.width / 2;
      const y = event.detail && event.clientY ? event.clientY : rect.top + rect.height / 2;
      const host = document.querySelector('dialog[open]') || document.body;
      const inDialog = host !== document.body;
      const origin = inDialog ? host.getBoundingClientRect() : { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
      const localX = Math.max(20, Math.min(origin.width - 20, x - origin.left));
      const localY = Math.max(30, Math.min(origin.height - 20, y - origin.top));
      const layer = document.createElement('span');
      layer.className = inDialog ? 'bbd-hw-effects bbd-hw-effects--dialog' : 'bbd-hw-effects';
      layer.setAttribute('aria-hidden', 'true');
      host.append(layer);
      const isCart = button.matches(cartSelector);
      const count = isCart || button.matches('.bbd-hw-badge') ? 7 : 4;
      for (let index = 0; index < count; index += 1) {
        const particle = document.createElement('span');
        particle.className = 'bbd-hw-particle';
        particle.innerHTML = index % 3 === 0 ? ghost : index % 3 === 1 ? bat : star;
        particle.style.left = `${localX - 12}px`;
        particle.style.top = `${localY - 12}px`;
        particle.style.color = index % 2 ? '#d58036' : '#50362b';
        layer.append(particle);
        const dx = (index - (count - 1) / 2) * 32;
        const dy = -48 - (index % 3) * 20;
        particle.animate([
          { transform: 'translate(0,0) scale(.35) rotate(0deg)', opacity: 0 },
          { offset: .18, opacity: 1 },
          { transform: `translate(${dx}px,${dy}px) scale(${index % 2 ? .5 : .85}) rotate(${dx / 3}deg)`, opacity: 0 }
        ], { duration: 900, easing: 'cubic-bezier(.16,.8,.32,1)', fill: 'forwards' });
      }
      window.setTimeout(() => layer.remove(), 960);
      const icon = button.querySelector('.bbd-hw-pumpkin');
      if (icon) {
        animations.get(icon)?.cancel();
        animations.set(icon, icon.animate([
          { transform: 'rotate(0deg)' }, { transform: 'rotate(-13deg)', offset: .2 },
          { transform: 'rotate(11deg)', offset: .42 }, { transform: 'rotate(-5deg)', offset: .68 },
          { transform: 'rotate(0deg)' }
        ], { duration: 520, easing: 'ease-out' }));
      }
    }

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest(actionSelector);
      if (!button || button.matches(':disabled,[aria-disabled="true"]')) return;
      if (button.matches('.bbd-hw-badge')) {
        const status = button.parentElement.querySelector('.bbd-hw-sr');
        if (status) status.textContent = status.textContent ? 'Un Halloween tout doux, avec BBD.' : 'Boo ! Même pas peur.';
      }
      window.requestAnimationFrame(() => { applyCartDecor(); burst(button, event); });
    }, { capture: true });
    document.addEventListener('shopify:section:load', applyDecor);
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) {
        document.querySelectorAll('.bbd-hw-effects').forEach((layer) => layer.remove());
        document.querySelectorAll('.bbd-hw-pumpkin').forEach((icon) => animations.get(icon)?.cancel());
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyDecor, { once: true });
    else applyDecor();
  })();
  } catch(e) { console.error(e); }
})();

})();
